"use client"

import { Suspense } from "react"
import { Preview } from "../../../../(admin)/modules/ui-builder/pages/preview"

function Page() {
  return (
    <Suspense fallback={null}>
      <Preview />
    </Suspense>
  )
}

export default Page
